import React from "react";
import { useQuery } from "@apollo/client";

import Stats from "./Stats";
import RoyaltiesNoActivity from "./RoyaltiesNoActivity";
import LoadingSpinner from "core/LoadingSpinner";
import MonthlyReport from "./monthly-report";
import HeadingCore from "core/Heading";

import { GET_PHOTO_ROYALTIES_STATEMENT_ALL } from "./queries";

import { userHasPhotoActivity } from "./helpers";

const Royalties = ({ username }) => {
    const { data, loading } = useQuery(GET_PHOTO_ROYALTIES_STATEMENT_ALL, {
        variables: {
            username
        }
    });

    if (loading) return <LoadingSpinner />;

    const {
        photoRoyaltyStatementsAndTotal: { statements, totals }
    } = data;

    if (!userHasPhotoActivity({ totals }) || statements.items.length === 0)
        return <RoyaltiesNoActivity />;

    const latestStatementMonth = statements && statements.items[0].month;

    return (
        <>
            <HeadingCore size="lg">
                Lifetime Summary Through {latestStatementMonth}
            </HeadingCore>

            <Stats totals={totals} />
            <MonthlyReport username={username} statements={statements} />
        </>
    );
};

export default Royalties;
